export const ONBOARDING_INITIAL_TASKS = [
  {
    name: '',
    defaultName: __('onboarding_wizard_group1_default_name'),
    uniqueTemplateText: 'group1',
    hidden: true,
  },
  {
    name: '',
    defaultName: __('onboarding_wizard_task1_default_name'),
    uniqueTemplateText: 'task1',
  },
  {
    name: '',
    defaultName: __('onboarding_wizard_task2_default_name'),
    uniqueTemplateText: 'task2',
  },
  {
    name: '',
    defaultName: __('onboarding_wizard_task3_default_name'),
    uniqueTemplateText: 'task3',
  },
];

// Configuration of all onboarding steps with enable/disable functionality
const ONBOARDING_STEPS_CONFIG = [
  {
    id: 'personalInfo',
    component: 'PersonalInfo',
    title: __('onboarding_personal_info_step_title'),
    enabled: true,
    order: 1,
  },
  {
    id: 'membersInfo',
    component: 'MembersInfo',
    title: __('onboarding_members_info_step_title'),
    enabled: true,
    order: 2,
  },
  {
    id: 'planningInfo',
    component: 'PlanningInfo',
    title: __('onboarding_planning_info_step_title'),
    enabled: true,
    order: 3,
  },
  {
    id: 'familiarityInfo',
    component: 'FamiliarityInfo',
    title: __('onboarding_familiarity_info_step_title'),
    enabled: false, // Disabled by request
    order: 4,
  },
  {
    id: 'featuresInfo',
    component: 'FeaturesInfo',
    title: __('onboarding_features_info_step_title'),
    enabled: false, // Disabled - replaced with industryInfo
    order: 5,
  },
  {
    id: 'industryInfo',
    component: 'IndustryInfo',
    title: __('onboarding_industry_info_step_title'),
    enabled: true,
    order: 5,
  },
  {
    id: 'wizardFirstProject',
    component: 'WizardMain',
    title: __('onboarding_wizard_first_project_step_title'),
    description: __('onboarding_wizard_first_project_step_descr'),
    isWizard: true,
    enabled: true,
    order: 6,
  },
  {
    id: 'wizardFirstTask',
    component: 'WizardMain',
    title: __('onboarding_wizard_first_task_step_title'),
    description: __('onboarding_wizard_first_task_step_descr'),
    isWizard: true,
    enabled: true,
    order: 7,
  },
  // {
  //   id: 'wizardFirstSubtask',
  //   component: 'WizardMain',
  //   title: 'Now let's create some tasks you need to complete',
  //   description: 'Specify several tasks that will be part of the project',
  //   isWizard: true,
  //   enabled: false,
  //   order: 8,
  // },
  {
    id: 'wizardFirstTeammate',
    component: 'WizardMain',
    title: __('onboarding_wizard_first_teammate_step_title'),
    description: __('onboarding_wizard_first_teammate_step_descr'),
    isWizard: true,
    enabled: true,
    order: 8,
  },
  {
    id: 'bookDemo',
    component: 'BookDemo',
    title: __('onboarding_book_demo_step_title'),
    description: __('onboarding_book_demo_step_descr'),
    enabled: true,
    order: 9,
  },
];

/**
 * Filter and sort enabled onboarding steps by order
 * Returns only steps where enabled: true, sorted by order property
 */
const ENABLED_STEPS = ONBOARDING_STEPS_CONFIG
  .filter(step => step.enabled)
  .sort((a, b) => a.order - b.order);

/**
 * Create array of step IDs for use in onboarding flows
 * Extracts step IDs from enabled steps to define flow order
 */
const DEFAULT_STEPS_ORDER = ENABLED_STEPS.map(step => step.id);

export const ONBOARDING_FLOWS = {
  OWNER_MANUALLY: {
    requiredRegistrationFields: ['firstName', 'lastName', 'password'],
    displayedFields: ['fullName', 'user_company', 'user_phone', 'password'],
    stepsOrder: DEFAULT_STEPS_ORDER,
  },
  OWNER_SOCIAL_NETWORKS: {
    requiredRegistrationFields: ['firstName', 'lastName'],
    displayedFields: ['fullName', 'user_company'],
    stepsOrder: DEFAULT_STEPS_ORDER,
  },
  TEAM_MEMBER_MANUALLY: {
    requiredRegistrationFields: ['firstName', 'lastName', 'password'],
    displayedFields: ['fullName', 'password'],
    stepsOrder: DEFAULT_STEPS_ORDER.slice(0, 1),
  },
  TEAM_MEMBER_SOCIAL_NETWORKS: {
    requiredRegistrationFields: ['firstName', 'lastName'],
    displayedFields: ['fullName'],
    stepsOrder: DEFAULT_STEPS_ORDER.slice(0, 1),
  },
};

// Export only enabled steps for use in the application
export const STEPS_CONFIG = ENABLED_STEPS;

export const ANALYTIC_TYPES = {
  GENERAL: 'general',
  INVITED: 'invited',
  MPP: 'mpp',
  TEMPLATE: 'template',
};

export const ANALYTIC_ACTIONS = {
  SKIP: 'skip',
  DONE: 'done',
  IMPORT_STARTED: 'importStarted',
  IMPORT_FINISHED: 'importFinished',
};
